import firebase from 'firebase';

/**
 * Factories promises that retreive the datasets this user has access to.
 */
class DatasetPromise {
  static _instance;

  static getInstance() {
    if (!DatasetPromise._instance) {
      DatasetPromise._instance = new DatasetPromise();
    }
    return DatasetPromise._instance;
  }

  static getUserClientData() {
    const dp = new DatasetPromise.getInstance();
    return dp.getUserClient(dp.uid)
      .then(dp.getClientData);
  }

  static getAdminDatasets() {
    const dp = new DatasetPromise.getInstance();
    return dp.getAllDatasetsFromClients();
  }

  static getPois() {
    const dp = new DatasetPromise.getInstance();
    return dp.getAllPois();
  }

  getClientData = (client) => {
    return this.getDbPromise(`/s6profiles/clients/${client}`).then(this.getVal);
  }

  constructor() {
    this.uid = firebase.auth().currentUser.uid;
  }

  getDbPromise = (refPath) =>
    firebase.database().ref(refPath).once('value');

  getVal = (res) => res.val();

  getUserClient = () => {
    return this.getDbPromise(`/s6profiles/users/${this.uid}/client`).then(this.getVal);
  }

  /**
   * Returns promise for admin
   */
  getAllDatasetsFromClients(clients) {
    return this.getDbPromise(`/s6profiles/clients/`)
      .then(this.getVal)
      .then(clients => {
        let returnObj = {};
        // Iterate through each client the get their datasets
        Object.keys(clients).forEach((value) => {
          // assign each dataset to the returnObj
          let datasets = clients[value].datasets;
          if (!datasets) return; // jump out if there is no dataset on this client

          Object.keys(datasets).forEach((datasetKey) => {
            returnObj[datasetKey] = datasets[datasetKey];
          });
        });

        return { datasets: returnObj, clients: clients };
      });
  }

  /**
   * Returns promise for POI list
   */
  getAllPois() {
    return this.getDbPromise(`/poi/categories`)
      .then(this.getVal);
  }

}

export default DatasetPromise;



// WEBPACK FOOTER //
// ./src/util/datasetPromise.js